import apiClient from '../apiClient';

const BASE = '/client-admin';

// Departments
export const getDepartments = () => apiClient.get(`${BASE}/departments`);
export const getOrgHierarchy = () => apiClient.get(`${BASE}/departments/org-hierarchy`);
export const createDepartment = (data) => apiClient.post(`${BASE}/departments`, data);
export const updateDepartment = (id, data) => apiClient.put(`${BASE}/departments/${id}`, data);
export const toggleDepartment = (id, isActive) => apiClient.patch(`${BASE}/departments/${id}/toggle`, { isActive });

// Teams
export const getTeams = (departmentId) => apiClient.get(`${BASE}/departments/${departmentId}/teams`);
export const createTeam = (departmentId, data) => apiClient.post(`${BASE}/departments/${departmentId}/teams`, data);
export const updateTeam = (teamId, data) => apiClient.put(`${BASE}/teams/${teamId}`, data);
export const toggleTeam = (teamId, isActive) => apiClient.patch(`${BASE}/teams/${teamId}/toggle`, { isActive });

// Team Members
export const getTeamMembers = (teamId) => apiClient.get(`${BASE}/teams/${teamId}/members`);
export const getAvailableLearners = (teamId, search = '', active = true) =>
    apiClient.get(`${BASE}/teams/${teamId}/available-learners`, { search, active });
export const addLearners = (teamId, userIds) => apiClient.post(`${BASE}/teams/${teamId}/members`, { userIds });
export const removeLearner = (teamId, userId) => apiClient.delete(`${BASE}/teams/${teamId}/members/${userId}`);
export const getTeamContent = (teamId) => apiClient.get(`${BASE}/teams/${teamId}/content`);
